import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/** Kodokan Goshin-jutsu — unarmed and weapons sets. */
export const kodokanGoshinJutsu: KataDefinition = withOpeningAndClosingBows({
  id: 'kodokan-goshin-jutsu',
  name: 'Kodokan Goshin-jutsu',
  nameJa: '講道館護身術',
  theme: {
    from: '#fde047',
    to: '#ca8a04',
    text: '#111111',
  },
  groups: [
    {
      id: 'unarmed-holds',
      name: 'Unarmed / holds',
      nameJa: '組みつかれた場合',
      techniques: [
        { id: 'goshin-ryote-dori', name: 'Ryote-dori', nameJa: '両手取' },
        { id: 'goshin-hidari-eri-dori', name: 'Hidari-eri-dori', nameJa: '左襟取' },
        { id: 'goshin-migi-eri-dori', name: 'Migi-eri-dori', nameJa: '右襟取' },
        { id: 'goshin-kata-ude-dori', name: 'Kata-ude-dori', nameJa: '片腕取' },
        { id: 'goshin-ushiro-eri-dori', name: 'Ushiro-eri-dori', nameJa: '後襟取' },
        { id: 'goshin-ushiro-jime', name: 'Ushiro-jime', nameJa: '後絞' },
        { id: 'goshin-kakae-dori', name: 'Kakae-dori', nameJa: '抱取' },
      ],
    },
    {
      id: 'unarmed-distance',
      name: 'Unarmed / distance attacks',
      nameJa: '離れた場合',
      techniques: [
        { id: 'goshin-naname-uchi', name: 'Naname-uchi', nameJa: '斜打' },
        { id: 'goshin-ago-tsuki', name: 'Ago-tsuki', nameJa: '顎突' },
        { id: 'goshin-ganmen-tsuki', name: 'Ganmen-tsuki', nameJa: '顔面突' },
        { id: 'goshin-mae-geri', name: 'Mae-geri', nameJa: '前蹴' },
        { id: 'goshin-yoko-geri', name: 'Yoko-geri', nameJa: '横蹴' },
      ],
    },
    {
      id: 'dagger',
      name: 'Dagger',
      nameJa: '短刀',
      techniques: [
        { id: 'goshin-tsukkake', name: 'Tsukkake', nameJa: '突掛' },
        { id: 'goshin-choku-tsuki', name: 'Choku-zuki', nameJa: '直突' },
        { id: 'goshin-naname-tsuki', name: 'Naname-zuki', nameJa: '斜突' },
      ],
    },
    {
      id: 'staff',
      name: 'Staff',
      nameJa: '杖',
      techniques: [
        { id: 'goshin-furi-age', name: 'Furi-age', nameJa: '振上' },
        { id: 'goshin-furi-oroshi', name: 'Furi-oroshi', nameJa: '振下' },
        { id: 'goshin-morote-tsuki', name: 'Morote-tsuki', nameJa: '双手突' },
      ],
    },
    {
      id: 'pistol',
      name: 'Pistol',
      nameJa: '拳銃',
      techniques: [
        { id: 'goshin-shomen-zuke', name: 'Shomen-zuke', nameJa: '正面付' },
        { id: 'goshin-koshi-gamae', name: 'Koshi-gamae', nameJa: '腰構' },
        { id: 'goshin-haimen-zuke', name: 'Haimen-zuke', nameJa: '背面付' },
      ],
    },
  ],
})
